// src/pages/MenuPage.js
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import HeaderSection from "../../../components/HeaderSection";
import { useDashboard } from "../../../contexts/DashboardProvider";
import CategoryListAdmin from "./CategoryListAdmin";
import MenuListAdmin from "./MenuListAdmin";
import ItemListAdmin from "./itemListAdmin";

const dimensions = {
  contentContainerWidth: 992,
  itemListBoxPadding: 16,
  upperContentHeight: 68,
};

const calculateDime = (screenSize = "md") => {
  const maxWidth = dimensions.contentContainerWidth + "px";
  let height = "";
  if (screenSize === "md") {
    height = `${dimensions.upperContentHeight}svh`;
  } else if (screenSize === "xs") {
    height = `55svh`;
  }
  return { maxWidth, height };
};

const Dashboard = () => {
  const theme = useTheme();

  const {
    menusCrud: { data: menus },
    activeMenu,
    handleMenuClick,
    categories,
    selectedCategory,
    handleCategoryClick,
    filteredItems,
  } = useDashboard();

  return (
    <Box
      sx={{
        display: "flex",
        height: "100svh",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        backgroundColor: theme.palette.primary.main,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          maxWidth: { md: calculateDime("md").maxWidth },
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: {
              xs: calculateDime("xs").height,
              md: calculateDime("md").height,
            },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: 0,
            m: 0,
            px: { xs: "16px", md: 0 },
          }}
        >
          <HeaderSection />
          <MenuListAdmin
            menus={menus}
            activeMenu={activeMenu}
            handleMenuClick={handleMenuClick}
          />
          <CategoryListAdmin
            categories={categories}
            selectedCategory={selectedCategory}
            handleCategoryClick={handleCategoryClick}
            menuId={activeMenu}
          />
        </Box>
        <ItemListAdmin
          items={filteredItems}
          selectedCategory={selectedCategory}
          dimensions={dimensions}
        />
      </Box>
    </Box>
  );
};

export default Dashboard;
